import React from 'react';
import { withRouter } from 'react-router-dom';

class EditarTipoConta extends React.Component {

    constructor() {

        super();

        this.state = {
            disabled: false,
            centroId: 0,
            centro: "",
            id: "",
            codConta: "",
            tipoConta: "",
            cor: "#FFFFFF",
            categoria: "Categoria",
            categoriaNome: "",
            categorias: [],
            corrente: ""
        };

        this.changeCodConta = this.changeCodConta.bind(this);
        this.changeTipoConta = this.changeTipoConta.bind(this);
        this.changeCor = this.changeCor.bind(this);
        this.changeCategoria = this.changeCategoria.bind(this);
        this.changeCorrente = this.changeCorrente.bind(this);
        this.salvar = this.salvar.bind(this);
        this.cancelar = this.cancelar.bind(this);

    }

    changeCodConta(e) {

        if (!isNaN(e.target.value)) {
            this.setState({ codConta: e.target.value });
        }

    }

    changeTipoConta(e) {
        this.setState({ tipoConta: e.target.value });
    }

    changeCor(e) {
        this.setState({ cor: e.target.value });
    }

    changeCategoria(e) {
        this.setState({ categoria: e.target.value });
    }

    changeCorrente(e) {
        if (e.target.value === "sim") this.setState({ corrente: true });
        else this.setState({ corrente: false });
    }

    salvar() {

        this.setState({ disabled: true });

        if (this.state.codConta === "") {

            this.props.errMsgHandler("Por favor, informe o código do tipo de conta.");
            this.setState({ disabled: false });

        } else if (this.state.tipoConta === "") {

            this.props.errMsgHandler("Por favor, informe a descrição do tipo de conta.");
            this.setState({ disabled: false });

        } else {

            this.props.errMsgHandler("");
            this.props.waitMsgHandler("Aguardando");

            let obj = {
                "id": this.state.id,
                "nome": this.state.tipoConta,
                "cod_conta": this.state.codConta,
                "cor": this.state.cor,
                "categoria": null,
                "centro_id": this.state.centroId,
                "corrente": this.state.corrente
            };

            if (this.state.categoria !== "Categoria") {
                obj.categoria = this.state.categoria;
            }

            fetch("/api/tipo_conta/", {
                method: "PUT",
                headers: {
                    "Content-type": "application/json",
                    "Authorization": "Basic " + btoa(localStorage.auth)
                },
                mode: "cors",
                body: JSON.stringify(obj)
            })
            .then(response => response.json())
            .then(responseJson => {

                if (responseJson.msg === "success") {

                    this.props.waitMsgHandler("");
                    this.props.successMsgHandler("Tipo de conta editado com sucesso.");

                    let obj2 = {
                        row: {
                            id: this.state.id,
                            data: [
                                this.state.tipoConta,
                                this.state.codConta
                            ]
                        }
                    };

                    this.props.history.push({
                        pathname: "/visualizartipoconta",
                        state: obj2
                    });

                }

            });

        }

    }

    cancelar() {

        let obj = {
            row: {
                id: this.state.id,
                data: [
                    this.state.tipoConta,
                    this.state.codConta
                ]
            }
        };

        this.props.history.push({
            pathname: "/visualizartipoconta",
            state: obj
        });

    }

    componentDidMount() {

        if (localStorage.roleContas !== "escrever") {
            window.location.href = "/home";
        }

        if (this.props.location.state === undefined) {
            window.location.href = "/contas";
        }

        let id = this.props.location.state.id;
        let codConta = this.props.location.state.codConta;
        let tipoConta = this.props.location.state.tipoConta;
        let cor = this.props.location.state.cor;
        let categoria = this.props.location.state.categoria;
        let categoriaId = this.props.location.state.categoriaId;
        let centroId = this.props.location.state.centroId;
        let centro = this.props.location.state.centro;

        this.setState({ id: id });
        this.setState({ codConta: codConta });
        this.setState({ tipoConta: tipoConta });
        this.setState({ cor: cor });
        this.setState({ categoriaNome: categoria });

        if (this.props.location.state.corrente === 1) this.setState({ corrente: true });
        else this.setState({ corrente: false });

        if (categoriaId === "") {

            this.setState({ categoria: "Categoria" });

        } else {

            this.setState({ categoria: categoriaId });

        }

        this.setState({ centroId: centroId });
        this.setState({ centro: centro });

        fetch("/api/tipo_conta/centro/" + centroId, {
            method: "GET",
            headers: {
                "Content-type": "application/json",
                "Authorization": "Basic " + btoa(localStorage.auth)
            },
            mode: "cors"
        })
        .then(response => response.json())
        .then(responseJson => {

            this.setState({ categorias: responseJson });

        });

    }

    render() {
        return(
            <div>
                <h1 id="editar-tipoconta-title">Editar Tipo de Conta</h1><br />
                <p id="editar-tipoconta-centro">
                    <b>Centro:</b> { this.state.centro }
                </p><br />
                <form id="editar-tipoconta-form">
                    <input type="text"
                        placeholder="Código"
                        value={ this.state.codConta }
                        onChange={ this.changeCodConta } />
                    <span Class="edtipoconta-somente-numeros">
                        (Somente valores númericos.)
                    </span><br />
                    <input type="text"
                        placeholder="Tipo de Conta"
                        value={ this.state.tipoConta }
                        onChange={ this.changeTipoConta } /><br />
                    <span Class="editar-tipoconta-cor-lbl">
                        <b>Cor: </b>
                    </span>
                    <input type="color"
                        placeholder="Cor"
                        value={ this.state.cor }
                        onChange={ this.changeCor } /><br />
                    <select value={ this.state.categoria } onChange={ this.changeCategoria }>
                        <option value="Categoria">Categoria</option>
                        { this.state.categorias.map((item, i) =>
                            <option key={ i } value={ item.id }>{ item.cod_conta } - { item.nome }</option> ) }
                    </select><br />
                    <ul class="edtipoconta-status-lst">
                        <li>
                            <b>Corrente: </b>
                            <label>
                                <input type="radio"
                                    name="corrente"
                                    value="sim"
                                    checked={ this.state.corrente === true }
                                    onChange={ this.changeCorrente } /> Sim
                            </label>
                            <label>
                                <input type="radio"
                                    name="corrente"
                                    value="não"
                                    checked={ this.state.corrente === false }
                                    onChange={ this.changeCorrente } /> Não
                            </label>
                        </li>
                    </ul><br /><br />
                    <button type="button" id="edtipoconta-cancelar-btn" onClick={ this.cancelar }>
                        Cancelar
                    </button>
                    <button type="button"
                        id="edtipoconta-salvar-btn"
                        onClick={ this.salvar }
                        disabled={ this.state.disabled }>
                        Salvar
                    </button>
                    <br /><br />
                </form>
            </div>
        );
    }

}

export default withRouter(EditarTipoConta);

